import { lazy } from 'react';

const DiscountPromoTool = lazy(() => import('../pages/DiscountPromoTool'));

// Hidden page: no menu entry, reachable by URL only.
const discountPromoToolRoute = {
  public: [],
  auth: [
    {
      name: 'discount_promo_tool',
      path: '/tools/discount-promo',
      component: DiscountPromoTool,
    },
  ],
};

export default discountPromoToolRoute;
